<template>
  <div class="pricing-section">
    <div class="text-subtitle-1 font-weight-bold primary--text mb-2">
      {{ $t("dependant.PricingTable.Title") }}:
    </div>
    <v-row
      align="start"
      justify="start"
      class="mt-2 mb-4 pricing-row"
      v-if="hasPricingTexts"
    >
      <v-col cols="12" md="7" class="pricing-info-col text-left">
        <div
          v-if="familyPricingTexts.length"
          class="text-subtitle-2 font-weight-bold primary--text mb-3"
        >
          <div
            v-for="item in familyPricingTexts"
            :key="`family-${item.name}`"
            class="pricing-line"
          >
            {{ item.text }}
          </div>
        </div>

        <div
          v-if="fixedPricingTexts.length"
          class="text-subtitle-2 font-weight-bold primary--text mb-3"
        >
          <div
            v-for="item in fixedPricingTexts"
            :key="`fixed-${item.name}`"
            class="pricing-line"
          >
            {{ item.text }}
          </div>
        </div>

        <div
          v-if="variablePricingTexts.length"
          class="text-subtitle-2 font-weight-bold primary--text mb-3"
        >
          <div
            v-for="group in variablePricingTexts"
            :key="`variable-${group.name}`"
            class="mb-3"
          >
            <div class="pricing-line">
              {{ group.title }}
            </div>

            <div
              v-for="item in group.items"
              :key="`variable-${group.name}-${item.dependantNumber}`"
              class="pricing-line"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    dependantSettings: Object,
  },
  components: {},
  data() {
    return {
      validDependantPeriod: {},
    };
  },
  computed: {
    ...mapGetters("common", ["canEditDependants"]),
    ...mapGetters("auth", ["user"]),
    pricingItems() {
      return this.validDependantPeriod?.Prices || [];
    },
    hasPricingTexts() {
      return (
        this.familyPricingTexts.length ||
        this.fixedPricingTexts.length ||
        this.variablePricingTexts.length
      );
    },
    familyPricingTexts() {
      return this.pricingItems
        .filter((p) => p.PricingType === "Family" && p.Amount != null)
        .map((p) => ({
          name: p.CoverageGroup?.Name,
          amount: p.Amount,
          text: `Add your family (includes all Dependants) to the ${
            p.CoverageGroup?.Name
          } for an additional: $${p.Amount.toFixed(2)}`,
        }));
    },

    fixedPricingTexts() {
      return this.pricingItems
        .filter((p) => p.PricingType === "Fixed" && p.Amount != null)
        .map((p) => ({
          name: p.CoverageGroup?.Name,
          amount: p.Amount,
          text: `Add your family to the ${
            p.CoverageGroup?.Name
          }: $${p.Amount.toFixed(2)} each dependant`,
        }));
    },
    variablePricingTexts() {
      return this.pricingItems
        .filter(
          (p) =>
            p.PricingType === "Variable" &&
            ((Array.isArray(p.Amounts) && p.Amounts.length > 0) ||
              p.SubsequentVariableAmount != null)
        )
        .map((p) => {
          const coverageName = p.CoverageGroup?.Name || "";

          const items = (p.Amounts || [])
            .filter((a) => a && a.Amount != null)
            .sort((a, b) => a.DependantNumber - b.DependantNumber)
            .map((a) => ({
              dependantNumber: a.DependantNumber,
              amount: a.Amount,
              text: `${this.getordinal(
                a.DependantNumber
              )} dependant for ${coverageName}: $${a.Amount.toFixed(2)}`,
            }));

          if (p.SubsequentVariableAmount != null) {
            items.push({
              dependantNumber: "additional",
              amount: p.SubsequentVariableAmount,
              text: `Each additional dependant for ${coverageName}: $${p.SubsequentVariableAmount.toFixed(
                2
              )}`,
            });
          }

          return {
            name: coverageName,
            title: `Add your family to ${coverageName}:`,
            items,
          };
        });
    },
  },
  async mounted() {
    console.log("DepentantSettings: ", this.dependantSettings);
    console.log("pricing table settings", this.dependantSettings);
    console.log("hasPricingTexts", this.hasPricingTexts);
    console.log("familyPricingTexts", this.familyPricingTexts);
    console.log("fixedPricingTexts", this.fixedPricingTexts);
    console.log("variablePricingTexts", this.variablePricingTexts);
    await this.loadCoverageGroups();
  },
  methods: {
    ...mapActions("data", ["getDependantValidPeriod"]),
    async loadCoverageGroups() {
      try {
        const periodResp = await this.getDependantValidPeriod({
          planId: this.user.plan,
          certificate: this.user.gatewayMemberId,
        });
        this.validDependantPeriod = periodResp.data.Response;
      } catch {
        this.validDependantPeriod = {};
      }
    },
    getordinal(number) {
      const suffixes = { one: "st", two: "nd", few: "rd", other: "th" };
      const pr = new Intl.PluralRules("en", { type: "ordinal" });
      const category = pr.select(number);
      return `${number}${suffixes[category]}`;
    },
  },
};
</script>
<style>
.pricing-line {
  margin-bottom: 8px;
  margin-top: 8px;
}
.pricing-info-col {
  text-align: left;
}
.pricing-section {
  width: 100%;
  text-align: left;
}
.pricing-row {
  margin-left: 12px;
}
</style>
